define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var PlanModel = /** @class */ (function () {
        function PlanModel(data) {
            this.Id = ko.observable(0);
            this.CopyFromId = ko.observable(0);
            this.Name = ko.observable();
            this.IsDefaultPlan = ko.observable(false);
            this.PlanType = ko.observable();
            this.ProviderId = ko.observable(0);
            this.ServiceTypeId = ko.observable(0);
            this.ProductTypeId = ko.observable(0);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, PlanModel.Mapping, self);
            }
        }
        PlanModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new PlanModel(options.data);
            }
        };
        return PlanModel;
    }());
    return PlanModel;
});
//# sourceMappingURL=PlanModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/PlanModel.js
// module id = 220
// module chunks = 2